import { render } from "./VideoInstruction.vue?vue&type=template&id=d98bcc30&scoped=true"
import script from "./VideoInstruction.vue?vue&type=script&lang=js"
export * from "./VideoInstruction.vue?vue&type=script&lang=js"

import "./VideoInstruction.vue?vue&type=style&index=0&id=d98bcc30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d98bcc30"]])

export default __exports__